import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Districts } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "../../assets/ts/components/_CookieComponent";

@Module
export default class DistrictModule extends VuexModule {
  @Action
  [Districts.findAll]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/districts/findAll", {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
}
